import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { getAccountName } from "../util";
import { BrowserTitleService } from "../common/browser-title/browser-title.service";
import { TranslateService } from "../common/translate/translate.service";
import { environment } from "environments/environment";
import { SnackbarService } from "app/common/snackbar/snackbar.service";

@Component({
	selector: "sdp-client-access",
	templateUrl: "./client-access.component.html"
})
export class ClientAccessComponent implements OnInit {
	public downloadUrl: string;
	public emailUrl = "";
	public demoSite = "";
	public readonly downloadIcon = { type: "material", name: "file_download", cssClass: "sdp-access-section-right-side-icon" };
	public readonly emailIcon = { type: "material", name: "email", cssClass: "sdp-access-section-right-side-icon" };
	public readonly copyIcon = { type: "material", name: "content_copy", cssClass: "sdp-access-section-right-side-icon" };
	public isWizard = true;
	public inviteOthersText: SafeHtml;

	constructor(
		private titleService: BrowserTitleService,
		private translateService: TranslateService,
		private snackbarService: SnackbarService,
		private sanitizer: DomSanitizer
	) {
		this.downloadUrl = environment.DOWNLOAD_SITE;
		this.inviteOthersText = this.sanitizer.bypassSecurityTrustHtml(this.translateService.translate("client.access.section.2.body"));
	}

	public async ngOnInit() {
		this.titleService.setTitle("client-download.header.title");
		this.emailUrl = `mailto:?subject=${encodeURIComponent(this.emailSubject)}&body=${encodeURIComponent(this.emailBody)}`;
	}

	public get emailBody() {
		return this.translateService.translate("download.email.template.body", {
			downloadUrl: environment.DOWNLOAD_SITE,
			accountName: getAccountName()
		});
	}

	public get emailSubject() {
		return this.translateService.translate("download.email.template.subject");
	}

	public copied() {
		this.snackbarService.open(this.translateService.translate("copy.email.template.toastr"));
	}
}
